module.exports = __webpack_public_path__ + "img/0.37416b42.png";